import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userInitials',
})
export class UserInitialsPipe implements PipeTransform {
  transform(userName: string): string {
    if (!userName?.trim()) return '';

    const nameParts = userName
      .trim()
      .split(' ')
      .filter(part => part);

    const firstInitial = nameParts[0]?.[0] ?? '';
    const lastInitial = nameParts.length > 1 ? (nameParts[1][0] ?? '') : '';

    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}
